@if(!deleteLoading){
<div id="crop-health-note-item" (click)="viewNote.emit(note)">
  <div class="note-title-container mb-1">
    <span class="note-label"> {{ note?.title }} </span>
    <div id="note-actions" class="note-action">
      <i class="ph-fill ph-dots-three-outline p-3" (click)="onShowActions($event)"></i>

      <p-popover #noteActionPopover>
        <div class="actions-panel">
          @if (permissionService.isGrantedOnUserPermissions('Note_Update')) {
            <div class="menu" (click)="edit($event)">{{ 'doktar_app.common.edit' | translate }}</div>
          }
          <div class="menu" (click)="share($event)">{{ 'doktar_app.common.share' | translate }}</div>
          <div class="menu" (click)="getDirection($event)">
            {{ 'doktar_app.common.get_directions' | translate }}
          </div>
          @if (permissionService.isGrantedOnUserPermissions('Note_Delete')) {
            <div class="menu delete" (click)="deleteNote($event)">{{ 'doktar_app.common.delete' | translate }}</div>
          }
        </div>
      </p-popover>
    </div>
  </div>
  <div class="note-date-tags-container mb-3">
    <div class="note-date">{{ note.createdAt | luxonFormat:'dd.MM.yyyy': ('UTC'+ plantationService.selectedPlantation?.offSet) }}</div>
    <span class="not-dot" [class.d-none]="!(note.noteTags?.length > 0)"></span>
    @if (note.problematicSpotId) {
    <span class="type-box">
      <span class="problematicSpot-tag"><i class="ph-fill ph-warning"></i></span>
      <span class="type-label">{{ 'doktar_app.common.problem' | translate }}</span>
    </span>
    }
    @for (tag of note.noteTags; track tag) {
    <span class="type-box">
      <img class="icon" [src]="getTagIcon(tag)" [alt]="tag.name" />
      <span class="type-label">{{ tag.name }}</span>
    </span>
    }
  </div>
  <p class="note-description">{{ displayNoteContent }}</p>

  @if(note.fileList?.length > 0) {
    <div class="note-image-container">
      <img class="note-image" [src]="note.fileList[0].photoUrl" [alt]="note.title || 'Note image'" /> 
    </div>
   }
</div>
} @else {
<p-skeleton width="10rem" height="1rem" styleClass="mb-3" />
<div class="d-flex gap-2">
  <p-skeleton width="6rem" height="1rem" styleClass="mb-3" />
  <p-skeleton width="6rem" height="2rem" styleClass="mb-3" />
  <p-skeleton width="6rem" height="2rem" styleClass="mb-3" />
</div>
}